import app from 'flarum/forum/app';
import Model from 'flarum/common/Model';
import ItemList from 'flarum/common/utils/ItemList';
import Badge from 'flarum/common/components/Badge';

export default class PrivatePicture extends Model {
    badges() {
        const items = new ItemList();

        if (this.id() === 'hidden') {
            items.add('hidden', Badge.component({
                type: 'hidden',
                icon: 'fas fa-trash',
                label: app.translator.trans('kilowhat-cimaise.forum.badge.hidden'),
            }));
        }

        if (this.id() === 'approval') {
            items.add('awaitingApproval', Badge.component({
                type: 'awaitingApproval',
                icon: 'fas fa-gavel',
                label: app.translator.trans('kilowhat-cimaise.forum.badge.awaiting-approval'),
            }));
        }

        return items;
    }
}
